import { GoogleAdsRequestGq, GoogleAdsRequestGqProps } from './GoogleAdsRequestGq';

export interface GoogleAdsRequestAnalysisGq {
  request: GoogleAdsRequestGq;
  completedCalls: number;
  queuedCalls: number;
  processingCalls: number;
  failedCalls: number;
  totalCalls: number;
  completedKeywords: number;
  suggestSeedsTotal: number;
  suggestSeedsCompleted: number;
  suggestSeedsPubSubPossibleFail: number;
  suggestSeedsCronJobFailed: number;
  suggestKeywordsBatching: boolean;
  comboTagsSettingUp: boolean;
  comboSettingUp: boolean;
}

export const GoogleAdsRequestAnalysisGqProps = `
  request {${GoogleAdsRequestGqProps}}
  completedCalls
  queuedCalls
  processingCalls
  failedCalls
  totalCalls
  completedKeywords
  suggestSeedsTotal
  suggestSeedsCompleted
  suggestSeedsPubSubPossibleFail
  suggestSeedsCronJobFailed
  suggestKeywordsBatching
  comboTagsSettingUp
  comboSettingUp
`;
